module.exports = __webpack_public_path__ + "static/img/s2.ea19080.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social/s2.jpg
// module id = r/f9
// module chunks = 0